import type { ComponentChildren } from 'preact';

// Inline reference to an in-app icon button or nav item, drawn as the actual
// icon (matching the product) rather than described in words. Wrap a Heroicon:
//   <DocIcon><EnvelopeIcon aria-hidden="true" /></DocIcon>
export function DocIcon({ children }: { children: ComponentChildren }) {
  return <span className="docs-doc-icon">{children}</span>;
}
